var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_2724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.709473,
    width: 23.3043,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_2724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0617 20.3L13.624 14.7C13.1385 15.1 12.5802 15.4167 11.949 15.65C11.3178 15.8833 10.6462 16 9.93415 16C8.17014 16 6.67721 15.3708 5.45535 14.1125C4.23349 12.8542 3.62256 11.3167 3.62256 9.5C3.62256 7.68333 4.23349 6.14583 5.45535 4.8875C6.67721 3.62917 8.17014 3 9.93415 3C11.6982 3 13.1911 3.62917 14.413 4.8875C15.6348 6.14583 16.2457 7.68333 16.2457 9.5C16.2457 10.2333 16.1325 10.925 15.9059 11.575C15.6793 12.225 15.3718 12.8 14.9834 13.3L20.4454 18.925C20.6234 19.1083 20.7124 19.3333 20.7124 19.6C20.7124 19.8667 20.6153 20.1 20.4211 20.3C20.2431 20.4833 20.0165 20.575 19.7414 20.575C19.4663 20.575 19.2397 20.4833 19.0617 20.3ZM9.93415 14C11.1479 14 12.1796 13.5625 13.0293 12.6875C13.8789 11.8125 14.3037 10.75 14.3037 9.5C14.3037 8.25 13.8789 7.1875 13.0293 6.3125C12.1796 5.4375 11.1479 5 9.93415 5C8.72038 5 7.68868 5.4375 6.83904 6.3125C5.98941 7.1875 5.56459 8.25 5.56459 9.5C5.56459 10.75 5.98941 11.8125 6.83904 12.6875C7.68868 13.5625 8.72038 14 9.93415 14Z",
    fill: "#7E7E7E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0e75b181fee6272bb4c8c407ab6c3d53.svg";
export { ForwardRef as ReactComponent };